var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level divide-x"},_vm._l((_vm.levels),function(level){return _c('div',{key:level,staticClass:"level-item"},[_vm._t("default",function(){return [_c('div',[_vm._v(_vm._s(level))])]},{"level":level})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }